module.exports = __webpack_public_path__ + "static/img/4areaB_10.b0d68cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_10.png
// module id = 1183
// module chunks = 1